import { builderSteps, type BuilderStep } from "../../stores/metadata-builder-store";

export function builderTextVisible(step: BuilderStep, path: string, bind: string) {
  let firstStep: BuilderStep | undefined;
  if (bind === "profile.artist_handle") firstStep = "credit";
  if (bind.startsWith("week.")) firstStep = "dates";
  if (bind === "day.date") firstStep = "oneSlot";
  if (bind === "origin") firstStep = "offline";
  const section = path.split(".")[2];
  if (section === "offline") return step === "offline" || step === "review";
  if (section === "one_slot") return step === "oneSlot" || step === "review";
  if (section === "two_slot") return step === "twoSlot" || step === "review";
  if (!firstStep) return false;
  return builderSteps.indexOf(step) >= builderSteps.indexOf(firstStep);
}
